@if (isListView) {
  <ng-container *transloco="let convert;">
    @if (showCheckboxColumnForListView) {
      <td>
        @if (isSharedListCheckboxEnabled()) {
          <span [class]="checkboxClassList">
            @if (isActiveAuctionButtons()) {
              <input data-testid="list-row-inventory-item-shared-checkbox" type="checkbox" class="custom-control-input"
                [id]="'list-view-bidlist-inventory-item-checkbox_' + bidItem.inventoryItemUuid"
                [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelSelectVehicleCheckbox')"
                (click)="toggleVehicleCheckboxSelected()" [checked]="isVehicleCheckboxSelected" [disabled]="!isPendingBuyerAction()" />
            }
            <label [for]="'list-view-bidlist-inventory-item-checkbox_' + bidItem.inventoryItemUuid"
            class="custom-control-label"></label>
          </span>
        }
        @if (isBidListCheckboxEnabled()) {
          <span [class]="checkboxClassList">
            <input data-testid="list-row-inventory-item-bidlist-checkbox" type="checkbox" class="custom-control-input"
              [id]="'list-view-bidlist-inventory-item-checkbox_' + bidItem.inventoryItemUuid"
              [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelSelectVehicleCheckbox')"
              (click)="toggleVehicleCheckboxSelected()" [checked]="isVehicleCheckboxSelected" [disabled]="!isRemovableBidListItem()" />
            <label [for]="'list-view-bidlist-inventory-item-checkbox_' + bidItem.inventoryItemUuid"
            class="custom-control-label"></label>
          </span>
        }
      </td>
    }
    <td data-testid="list-row-inventory-item-vin" class="vin">{{ bidItem.itemDetail.vin ? bidItem.itemDetail.vin : '' }}</td>
    @if(showInspectionSeries) {
      <td data-testid="list-row-inventory-item-inspection-series">{{ inspectionSeries }}</td>
    }
    <td class="vehicle-title" title="{{ titleList }}" [ngClass]="{ 'sharedListVehicleTitle': isSharedList, 'vehicle-title-ca': !showDelivery}">
      <a data-testid="list-row-inventory-item-title-link" class="btn btn-link text-primary" [attr.allytmln]="bidItem.inventoryItemUuid + ' - VDP'"
        allytm-click-tagged="true" (click)="_analyticsService.trackEvent('link', bidItem.inventoryItemUuid + ' - VDP')"
      [routerLink]="vdpLinkList">{{ titleList }}</a>
    </td>
    <td data-testid="list-row-inventory-item-color" class="color">{{ bidItem.itemDetail.color ? bidItem.itemDetail.color : 'N/A' }}</td>
    <td data-testid="list-row-inventory-item-odometer" class="odometer">{{ get('itemDetail.odometer', false) ? (get('itemDetail.odometer') | number) : 'N/A' }}
    </td>
    <td class="seller-offer" [ngClass]="limitedOffer">
      @if (!isSharedList) {
        <span data-testid="list-row-inventory-item-opening-price" class="opening-price-offer" [class]="'vehicle_opening_price_text_' + index">{{
          formatCurrency(listViewCurrentAmount, false)
        }}</span>
        @if (showDripCurrentAmountTooltip && dripCurrentAmountTooltip) {
          <app-tooltip class="drip-info-icon" data-testid="list-row-inventory-item-all-in-price-tooltip" [tooltip]="dripCurrentAmountTooltip"
            id="{{ 'allInPriceTooltip_' + index }}" [showToolTipAsHtml]="true"
            [triggers]="dripTooltipTriggers" allytmln="All In Price Details"
            (click)="analyticsInfo('All In Price Details')">
            <i class="allycon-info-outline text-primary do-not-print" aria-hidden="true"></i>
          </app-tooltip>
        }
      }
      @if (isSharedList) {
        <span data-testid="list-row-inventory-item-offer-amount" class="offer-amount-list-view" [class]="'vehicle_offered_amount_text_' + index">{{
          formatCurrency(get('offerAmount'), false)
        }}</span>
      }
      @if (isSharedList && bidItem.buyerAuctionItemStatus !== 'SOLD' && bidItem.buyerAuctionItemStatus !== 'WON' ) {
        <span class="seller-offer-details-tooltip">
          <app-tooltip data-testid="list-row-inventory-item-seller-offer-tooltip" [tooltip]="sellerOfferTooltip" id="{{ 'sellerOfferTooltip_' + index }}"
            [showToolTipAsHtml]="true" triggers="hover :keydown.escape :keydown.tab click"
            allytmln="Seller Offer Details">
            <i class="allycon-clock ms-2 clock" aria-hidden="true"
            [ngClass]="allyconClockClass"></i>
          </app-tooltip>
        </span>
      }
    </td>
    <td class="fees">
      @if (!showFees) {
        N/A
      } @else {
        {{ formatCurrency(this.bidItem.buyFee.total, true)}}
        <ng-container>
          @if (hasFeeDetails()) {
            <span class="fee-details-tooltip">
              <app-tooltip data-testid="list-row-inventory-item-fee-details-tooltip" [tooltip]="feeDetailsTooltip" id="{{ 'feeDetailsTooltip_' + index }}" [showToolTipAsHtml]="true"
                role="tooltip" triggers="click :keydown.escape :keydown.tab" allytmln="Service Fee Details"
                (click)="analyticsInfo('Service Fee Details')">
                <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
              </app-tooltip>
            </span>
          }
        </ng-container>
      }
    </td>
    <!--
      Shared list only. SAT-94660: the buyer bid list's list view does not carry this column; its
      Total Purchase Price stays on the card view. The <th> in common-list must match this gate.
    -->
    @if (isSharedList) {
      <td data-testid="list-row-inventory-item-total-purchase-price" class="total-purchase-price">
        <ng-container>
          {{ formatCurrency(getTotalPurchasePrice, showTotalPurchasePriceWithCents) }}
        </ng-container>
      </td>
    }
    @if (showDelivery || showShippingQuote) {
      <td class="delivery">
        <ng-container class="ps-2 pe-1">
          @if (showDelivery) {
            @if (isDeliveryEditable) {
              <a data-testid="list-row-inventory-item-edit-delivery-link" href="#" (click)="openEditDeliveryModal($event, true)" class="edit-delivery__link text-bold"
                aria-label="Edit Delivery" data-track-elem="button" data-track-name="Delivery | Edit"
              data-track-trigger="modal">{{ getTranslatedLocalDeliveryString(bidItem.localDelivery) }}</a>
            } @else {
              {{getTranslatedLocalDeliveryString(bidItem.localDelivery)}}
            }
          }
          @if (showShippingQuote) {
            <app-transportation-estimate data-testid="list-row-inventory-item-shipping-estimate" [transportationQuote]="bidItem.transportationQuote"
              [transportationTranslate]="bidlistInventoryItemTranslations.transTranslations" mode="estimate"
              [showDeliveryLink]="isDeliveryLinkDisplayed" [index]="index"
              [inventoryItemUuid]="bidItem.inventoryItemUuid">
            </app-transportation-estimate>
          }
        </ng-container>
      </td>
    }
    <td class="credit-line" title="{{financeSourceName}}">
      @if (!isEditable) {
        <span>{{ financeSourceName }}</span>
      }
      @if (showFinanceSourcesPopover) {
        <app-finance-sources-popover data-testid="list-row-inventory-item-finance-popover" [tenantName]="tenantName"
          [selectedFinanceSource]="selectedFinanceSource" [financeSources]="scopedFinanceSources"
          [auctionItemStatus]="bidItem.auctionItemStatus" (sourceSelected)="updateFinanceSource($event)">
        </app-finance-sources-popover>
      }
      @if (showFinanceSourceNotPopover) {
        <span>{{ financeSourceName }}</span>
      }
      @if (hasFinanceInlineError) {
        <p data-testid="list-row-inventory-item-finance-error" class="mb-0 error-message text-bold text-destructive" aria-live="polite"
          aria-atomic="true">
          {{ financeInlineError }}
        </p>
      }
      @if (isEditable && !selectedFinanceSource) {
        <span>N/A</span>
      }
    </td>
    <td data-testid="list-row-inventory-item-status" class="status">{{ (bidItem.buyerAuctionItemStatus | badgeStatus).text }}</td>
    <td class="ellipsis">
      @if (showEllipsis) {
        <div class="dropdown">
          <trap-focus [enableFocusTrap]="isPopoverOpen" [focusOnFirstElem]="true">
            <button data-testid="list-row-inventory-item-actions-button" class="ellipsis_button" [popover]="actionsModal" #kabobPopOver="bs-popover" placement="bottom"
              triggers="click :keydown.escape :keydown.tab: keydown.enter" [outsideClick]="true"
              aria-label="ellipsis button" (onShown)="isPopoverOpen = true" (onHidden)="isPopoverOpen = false"
              [attr.aria-expanded]="isPopoverOpen" allytmln="List View Ellipses" aria-haspopup="true">
              <div class="dot" aria-label="ellipsis dot" role="dialog"></div>
              <div class="dot" aria-label="ellipsis dot" role="dialog"></div>
              <div class="dot" aria-label="ellipsis dot" role="dialog"></div>
              <ng-template #actionsModal>
                <button data-testid="list-row-inventory-item-actions-close-button" #closeButton id="close_x_button" class="modal__close-btn"
                  [attr.aria-label]="convert('common.modalClose')" data-track-elem="icon" data-track-name="close"
                  data-track-trigger="close" (click)="closePopover()" title="close x button">
                  <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
                </button>
                <ng-container>
                  <ng-container>
                    @if (isSharedList && activeAuctionButtons) {
                      <ng-content *ngTemplateOutlet="listViewActiveAuctionButtons"></ng-content>
                    }
                    @if (!isSharedList) {
                      <ng-content *ngTemplateOutlet="listViewWithdrawButton"></ng-content>
                      <ng-content *ngTemplateOutlet="listViewBidButton"></ng-content>
                    }
                    <ng-content *ngTemplateOutlet="listViewOfferButton"></ng-content>
                    @if (!isSharedList) {
                      <ng-content *ngTemplateOutlet="listViewBuyNowButton"></ng-content>
                    }
                  </ng-container>
                </ng-container>
              </ng-template>
            </button>
          </trap-focus>
        </div>
      }
    </td>
    <ng-template #listViewActiveAuctionButtons>
      <button data-testid="list-row-inventory-item-accept-button" [attr.id]="
        convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow') === 'Accept Offer'
            ? 'vehicle_accept_offer_button_' + index
            : 'vehicle_view_offer_button_accept' + index
        " class="btn btn-link text-primary decision-link" role="button"
        (click)="openSharedListCommonActionModal('ACCEPT')"
        [attr.allytmln]="'listAccept'" [attr.data-track-name]="accept" data-track-trigger="modal"
        data-track-elem="button" [attr.aria-label]="convert('vehicles.counterOffer.btnAccept')"
        [appTrackButton]="convert('vehicles.counterOffer.btnAccept')" #offerActionButton tabindex="0">
        {{ convert('vehicles.counterOffer.btnAccept') | titlecase}}
      </button>
      @if (this.vehicleTypeCode !== 'ISV') {
        <br>
          <button data-testid="list-row-inventory-item-counter-button" class="btn btn-link text-primary decision-link" role="button"
            (click)="openSharedListCommonActionModal('COUNTER')"
            [attr.allytmln]="'listCounter'" appTrackButton="counter" data-track-name="counter"
            data-track-trigger="modal" data-track-elem="button"
            [attr.aria-label]="convert('vehicles.counterOffer.btnCounter')" [id]="'vehicle_buy_now_button_' + index"
            tabindex="0">
            {{ convert('vehicles.counterOffer.btnCounter') | titlecase}}
          </button>
          <br>
        <button data-testid="list-row-inventory-item-decline-button" [attr.id]="
          convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow') === 'Decline Offer'
              ? 'vehicle_decline_offer_button_' + index
              : 'vehicle_view_offer_button_decline' + index
          " class="btn btn-link text-primary decision-link" role="button"
              (click)="openSharedListCommonActionModal('DECLINE')"
              [attr.allytmln]="'listDecline'" [attr.data-track-name]="convert('vehicles.counterOffer.btnDecline')" data-track-trigger="modal"
              data-track-elem="button" [attr.aria-label]="convert('vehicles.counterOffer.btnDecline')"
              [appTrackButton]="convert('vehicles.counterOffer.btnDecline')" #offerActionButton tabindex="0">
              {{ convert('vehicles.counterOffer.btnDecline') | titlecase}}
            </button>
          }
        </ng-template>
        <ng-template #listViewWithdrawButton>
          @if (bidItem.autoBidStatus === 'PENDING' && isAutoBidEnabled) {
            <button data-testid="list-row-inventory-item-withdraw-button" class="btn btn-link text-primary decision-link" appTrackButton="Withdraw"
              data-track-name="Withdraw"
              data-track-elem="button" data-track-trigger="modal" (click)="openAutoBidWithdrawModal()"
              [attr.allytmln]="'listWithdraw'" [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelWithdraw')"
              [id]="'vehicle_withdraw_button_' + index" tabindex="0">
              {{ convert('vehicles.bidlistInventoryItem.ariaLabelWithdraw') | titlecase }}
            </button>
          }
        </ng-template>
        <ng-template #listViewBidButton>
          @if (showBidButton()) {
            <button data-testid="list-row-inventory-item-bid-button" class="btn btn-link text-primary decision-link" appTrackButton="Bid"
              data-track-name="Bid" data-track-elem="button" data-track-trigger="modal" (click)="openBidModal()"
              [attr.allytmln]="bidButtonAnalyticsText(bidItem.autoBidStatus)"
              [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelBid')" [id]="'vehicle_bid_button_' + index"
              tabindex="0">
              {{ bidItem.autoBidStatus | autoBidButtonText }}
            </button>
          }
        </ng-template>
        <ng-template #listViewOfferButton>
          @if (showOfferButton() && (!isSharedList || !activeAuctionButtons)) {
<button data-testid="list-row-inventory-item-offer-button" [attr.id]="
          (bidItem.buyerAuctionItemStatus | offerButtonText) === 'Make Offer'
            ? 'vehicle_make_offer_button_' + index
            : 'vehicle_view_offer_button_' + index
        "
              class="btn btn-link text-primary decision-link" role="button" [disabled]="waitingForOffers"
              (click)="openOfferModals()"
              [attr.allytmln]="offerButtonAnalyticsText(bidItem.buyerAuctionItemStatus)"
              [attr.data-track-name]="bidItem.buyerAuctionItemStatus | offerButtonText"
              data-track-trigger="modal" data-track-elem="button"
              [attr.aria-label]="bidItem.buyerAuctionItemStatus | offerButtonText"
              [appTrackButton]="bidItem.buyerAuctionItemStatus | offerButtonText" #offerActionButton>
              {{ bidItem.buyerAuctionItemStatus | offerButtonText }}
            </button>
          }
        </ng-template>
        <ng-template #listViewBuyNowButton>
          @if (showBuyNowButton()) {
            <button data-testid="list-row-inventory-item-buy-now-button" class="btn btn-link text-primary decision-link" (click)="openBuyNowModals()"
              appTrackButton="Buy Now" data-track-name="Buy Now" data-track-trigger="modal" data-track-elem="button"
              [attr.allytmln]="'listBuyNow'"
              [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow')"
              [id]="'vehicle_buy_now_button_' + index" tabindex="0">
              {{ convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow') | titlecase }}
            </button>
          }
        </ng-template>
      </ng-container>
    }
